module.exports = __webpack_public_path__ + "img/auto-bg-1.a5bdb227.jpg";